<template>
  <div class="row">
    <el-drawer title="" :visible.sync="showForm" direction="btt" :before-close="handleClose" size="90%"
      :destroy-on-close="true">
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <vessel-form @save="getVessels()" v-if="showForm" :vessel="selected"></vessel-form>
        </div>
      </div>
    </el-drawer>

    <el-drawer title="" :visible.sync="viewVesselSeats" direction="btt" :before-close="handleClose" size="90%"
        :destroy-on-close="true">
        <div class="" v-if="selected">
          <vessel-seats-list :vessel="selected"></vessel-seats-list>
        </div>
      </el-drawer>

    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Manage Vessels</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select class="select-default" v-model="pagination.perPage" placeholder="Per page" size="small">
            <el-option class="select-default" v-for="item in perPageOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          <el-button type="primary" size="small" class="ml-2" @click="handleForm">New +</el-button>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input class="input-sm" placeholder="Search" v-model="term" addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped" header-row-class-name="text-primary" :data="vessels" style="width: 100%">


            <el-table-column :min-width="120" class-name="td-actions" label="Name">
              <template slot-scope="props">
                {{ props.row.name }}
              </template>
            </el-table-column>

            <el-table-column :min-width="120" class-name="td-actions" label="CODE">
              <template slot-scope="props">
                {{ props.row.code }}
              </template>
            </el-table-column>

            <el-table-column :min-width="120" class-name="td-actions" label="capacity">
                <template slot-scope="props">
                  {{ props.row.total_seats }}
                </template>
              </el-table-column>
            

            <el-table-column :min-width="120" class-name="td-actions" label="Actions">
              <template slot-scope="props">

                <el-button type="primary" plain link @click="handleViewSeats(props.row)" size="mini">
                    Manage Seats
                    <i class="fa fa-eye"></i>
                  </el-button>
                <el-button type="default" link @click="handleEdit(props.row)" size="mini">
                  <i class="fa fa-edit"></i>
                </el-button>
                <confirm-delete @onClick="handleDelete(props.row)" :label="'Delete'"></confirm-delete>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Found {{ pagination.total }} data</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right" v-model="pagination.currentPage" :per-page="pagination.perPage"
            :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { Vessel } from '@/resources/vessel'
import ConfirmDelete from '../../Common/ConfirmDelete.vue'
import VesselForm from './VesselForm.vue'
import VesselSeatsList from './VesselSeatsList.vue'

export default {
  components: { ConfirmDelete, VesselForm, VesselSeatsList },
  data() {
    return {
      showDelete: false,
      viewVesselSeats: false,
      showForm: false,
      vessels: [],
      selected: null,
      perPageOptions: [5, 10, 15],
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0
      },
      term: null,
    }
  },
  watch: {
    term: function () {
      if (!this.term || this.term.length > 2) {
        this.getVessels()
      }
    },
    'pagination.perPage': function () {
      if (this.pagination.currentPage == 1) {
        this.getVessels()
      } else {
        this.pagination.currentPage = 1
      }
    },
    'pagination.currentPage': function () {
      this.getVessels()
    }
  },
  created: function () {
    this.getVessels()
  },
  methods: {
    handleViewSeats(model) {
      this.viewVesselSeats = true
      this.selected = Object.assign({}, model)
    },
    handleEdit(model) {
      this.showForm = true
      this.selected = Object.assign({}, model)
    },
    handleClose() {
      this.showDelete = false
      this.showForm = false
      this.viewVesselSeats = false
    },
    handleForm() {
      this.showForm = true
      this.selected = null
    },
    handleDelete(model) {
      this.$loading = true
      this.$loadingText = "Removing"

      Vessel.delete({ id: model.id })
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: 'Vessel has been removed',
          });
          this.getVessels()
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    getVessels() {
      this.handleClose()
      let params = { term: this.term, status: this.status, page: this.pagination.currentPage, per_page: this.pagination.perPage }
      this.$loading = true
      Vessel.get({ params: params })
        .then(result => {
          if (result.data.vessels)
            this.vessels = result.data.vessels
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    }
  }
}
</script>
<style lang="scss"></style>
